export default class Order {
  static async retrieve(axios, id) {
    const response = await axios.post(
      "/graphql/",
      `query{
        orderRetrieve(id: ${id}) {
          id
          dateTime
          couponsInstance {
            coupons {
              active
              id
              title
              subTitle
              categories {
                id
                name
              }
              images {
                id
                url
              }
              initialDate
              expirationDate
              description
              discount
              distinguished
              hot
              new
              price
              saveValue
              value
            }
          }
          user {
            id
            username
            firstName
            lastName
            email
            groups {
              id
              name
              permissions {
                id
                name
              }
            }
            isActive
            isStaff
            userPermissions {
              id
              name
            }
          }
          payment {
            id
            type
            amount
            dateTime
            brand
            last4  
            status   
            origin    
            couponoffprofile{
              couponOff{
                id
                code
                off
              }
            }   
            shoppingCars {
              coupons {
                id
                title
                subTitle
                description
                price
                saveValue
              }
              amount
            }
          }
        }
      }`,
      {
        headers: {
          "Content-Type": "application/graphql",
        },
      }
    );

    if (response.data.data.orderRetrieve.payment.type === "C") {
      response.data.data.orderRetrieve.payment.type = "TARJETA";
    } else {
      response.data.data.orderRetrieve.payment.type = "OXXO";
      response.data.data.orderRetrieve.payment.last4 = null;
      if (response.data.data.orderRetrieve.payment.status == "P")
        response.data.data.orderRetrieve.payment.status = "En proceso";
      else if (response.data.data.orderRetrieve.payment.status == "S")
        response.data.data.orderRetrieve.payment.status = "Pagado";
      else if (response.data.data.orderRetrieve.payment.status == "C")
        response.data.data.orderRetrieve.payment.status = "Cancelado";
      else if (response.data.data.orderRetrieve.payment.status == "F")
        response.data.data.orderRetrieve.payment.status = "Fallido";
    }

    if (response.data.data.orderRetrieve.payment.status == null) {
      response.data.data.orderRetrieve.payment.status = "---";
    }

    return response.data.data.orderRetrieve;
  }

  static async all(axios) {
    const response = await axios.post(
      "/graphql/",
      `query {
        orderList {
          results {
            id
            dateTime
            couponsInstance {
              coupons {
                active
                id
                title
                subTitle
                categories {
                  id
                  name
                }
                images {
                  id
                  url
                }
                initialDate
                expirationDate
                description
                discount
                distinguished
                hot
                new
                price
                saveValue
                value
              }
            }
            user {
              id
              username
              firstName
              lastName
              email
              groups {
                id
                name
                permissions {
                  id
                  name
                }
              }
              isActive
              isStaff
              userPermissions {
                id
                name
              }
            }
            payment {
              id
              type
              amount
              dateTime
              brand
              origin
              last4  
              status
              couponoffprofile{
                couponOff{
                  id
                  code
                  off
                }
              }           
              shoppingCars {
                coupons {
                  id
                  title
                  subTitle
                  description
                  price
                  saveValue
                }
                amount
              }
            }
          }
        }
      }`,
      {
        headers: {
          "Content-Type": "application/graphql",
        },
      }
    );

    for (var i = 0; i < response.data.data.orderList.results.length; i++) {
      if (response.data.data.orderList.results[i].payment.type === "C") {
        response.data.data.orderList.results[i].payment.type = "TARJETA";
      } else if (response.data.data.orderList.results[i].payment.type === "K"){
        response.data.data.orderList.results[i].payment.type = "CONEKTA";
      }
      else if (response.data.data.orderList.results[i].payment.type === "P"){
        response.data.data.orderList.results[i].payment.type = "PAYPAL";
      }
      else {
        response.data.data.orderList.results[i].payment.type = "OXXO";
        response.data.data.orderList.results[i].payment.last4 = null;
        if (response.data.data.orderList.results[i].payment.status === "P")
          response.data.data.orderList.results[i].payment.status = "En proceso";
        else if (response.data.data.orderList.results[i].payment.status === "S")
          response.data.data.orderList.results[i].payment.status = "Pagado";
        else if (response.data.data.orderList.results[i].payment.status === "C")
          response.data.data.orderList.results[i].payment.status = "Cancelado";
        else if (response.data.data.orderList.results[i].payment.status === "F")
          response.data.data.orderList.results[i].payment.status = "Fallido";
      }

      if (response.data.data.orderList.results[i].payment.status == null) {
        response.data.data.orderList.results[i].payment.status = "---";
      }
    }

    return response.data.data.orderList.results.reverse();
  }

  static async allOfBranchOffice(axios, branchOffice, init, last) {
    let initField =
      init !== "" && init !== undefined ? `, dateTime_Gte: "${init}"` : "";
    let lastField =
      last !== "" && last !== undefined ? `, dateTime_Lte: "${last}"` : "";
    const response = await axios.post(
      "/graphql/",
      `query {
        orderBranchOffice(branchOfficeId: ${branchOffice} ${initField} ${lastField}) {
          id
          dateTime
          couponsInstance {
            coupons {
              active
              id
              title
              subTitle
              categories {
                id
                name
              }
              images {
                id
                url
              }
              initialDate
              expirationDate
              description
              discount
              distinguished
              hot
              new
              price
              saveValue
              value
            }
          }
          user {
            id
            username
            firstName
            lastName
            email
            groups {
              id
              name
              permissions {
                id
                name
              }
            }
            isActive
            isStaff
            userPermissions {
              id
              name
            }
          }
          payment {
            id
              type
              amount
              dateTime
              brand
              origin
              last4 
              status    
              couponoffprofile{
                couponOff{
                  id
                  code
                  off
                }
              }       
            shoppingCars {
              coupons {
                id
                title
                subTitle
                description
                price
                saveValue
              }
              amount
            }
          }
        }
      }`,
      {
        headers: {
          "Content-Type": "application/graphql",
        },
      }
    );

    if (response.data.data.orderBranchOffice.payment.type === "C") {
      response.data.data.orderBranchOffice.payment.type = "TARJETA";
    } else {
      response.data.data.orderBranchOffice.payment.type = "OXXO";
      response.data.data.orderBranchOffice.payment.last4 = null;
      if (response.data.data.orderBranchOffice.payment.status == "P")
        response.data.data.orderBranchOffice.payment.status = "En proceso";
      else if (response.data.data.orderBranchOffice.payment.status == "S")
        response.data.data.orderBranchOffice.payment.status = "Pagado";
      else if (response.data.data.orderBranchOffice.payment.status == "C")
        response.data.data.orderBranchOffice.payment.status = "Cancelado";
      else if (response.data.data.orderBranchOffice.payment.status == "F")
        response.data.data.orderBranchOffice.payment.status = "Fallido";
    }

    if (response.data.data.orderBranchOffice.payment.status == null) {
      response.data.data.orderBranchOffice.payment.status = "---";
    }

    return response.data.data.orderBranchOffice;
  }

  static async allOfCompany(axios, company, init, last) {
    let initField =
      init !== "" && init !== undefined ? `, dateTime_Gte: "${init}"` : "";
    let lastField =
      last !== "" && last !== undefined ? `, dateTime_Lte: "${last}"` : "";
    const response = await axios.post(
      "/graphql/",
      `query {
        orderCompany(companyId: ${company} ${initField} ${lastField}) {
          id
          dateTime
          couponsInstance {
            coupons {
              active
              id
              title
              subTitle
              categories {
                id
                name
              }
              images {
                id
                url
              }
              initialDate
              expirationDate
              description
              discount
              distinguished
              hot
              new
              price
              saveValue
              value              
            }
          }
          user {
            id
            username
            firstName
            lastName
            email
            groups {
              id
              name
              permissions {
                id
                name
              }
            }
            isActive
            isStaff
            userPermissions {
              id
              name
            }
          }
          payment {
            id
            type
            amount
            dateTime
            brand
            origin
            last4    
            status  
            couponoffprofile{
              couponOff{
                id
                code
                off
              }
            }      
            shoppingCars {
              coupons {
                id
                title
                subTitle
                description
                price
                saveValue
              }
              amount
            }
          }
        }
      }`,
      {
        headers: {
          "Content-Type": "application/graphql",
        },
      }
    );
    if (response.data.data.orderCompany.payment.type === "C") {
      response.data.data.orderCompany.payment.type = "TARJETA";
    } else {
      response.data.data.orderCompany.payment.type = "OXXO";
      response.data.data.orderCompany.payment.last4 = null;
      if (response.data.data.orderCompany.payment.status == "P")
        response.data.data.orderCompany.payment.status = "En proceso";
      else if (response.data.data.orderCompany.payment.status == "S")
        response.data.data.orderCompany.payment.status = "Pagado";
      else if (response.data.data.orderCompany.payment.status == "C")
        response.data.data.orderCompany.payment.status = "Cancelado";
      else if (response.data.data.orderCompany.payment.status == "F")
        response.data.data.orderCompany.payment.status = "Fallido";
    }

    if (response.data.data.orderCompany.payment.status == null) {
      response.data.data.orderCompany.payment.status = "---";
    }

    return response.data.data.orderCompany;
  }

  static async filter(axios, init, last) {
    const response = await axios.post(
      "/graphql/",
      `query {
        orderList (dateTime_Gte: "${init}", dateTime_Lte: "${last}") {
          results {
            id
            dateTime
            couponsInstance {
              coupons {
                active
                id
                title
                subTitle
                categories {
                  id
                  name
                }
                images {
                  id
                  url
                }
                initialDate
                expirationDate
                description
                discount
                distinguished
                hot
                new
                price
                saveValue
                value
              }
            }
            user {
              id
              username
              firstName
              lastName
              email
              groups {
                id
                name
                permissions {
                  id
                  name
                }
              }
              isActive
              isStaff
              userPermissions {
                id
                name
              }
            }
            payment {
              id
              type
              amount
              dateTime
              brand
              origin
              last4  
              status  
              couponoffprofile{
                couponOff{
                  id
                  code
                  off
                }
              }          
              shoppingCars {
                coupons {
                  id
                  title
                  subTitle
                  description
                  price
                  saveValue
                }
                amount
              }
            }
          }
        }
      } `,
      {
        headers: {
          "Content-Type": "application/graphql",
        },
      }
    );

    for (var i = 0; i < response.data.data.orderList.results.length; i++) {
      if (response.data.data.orderList.results[i].payment.type === "C") {
        response.data.data.orderList.results[i].payment.type = "TARJETA";
      } else {
        response.data.data.orderList.results[i].payment.type = "OXXO";
        response.data.data.orderList.results[i].payment.last4 = null;
        if (response.data.data.orderList.results[i].payment.status == "P")
          response.data.data.orderList.results[i].payment.status = "En proceso";
        else if (response.data.data.orderList.results[i].payment.status == "S")
          response.data.data.orderList.results[i].payment.status = "Pagado";
        else if (response.data.data.orderList.results[i].payment.status == "C")
          response.data.data.orderList.results[i].payment.status = "Cancelado";
        else if (response.data.data.orderList.results[i].payment.status == "F")
          response.data.data.orderList.results[i].payment.status = "Fallido";
      }

      if (response.data.data.orderList.results[i].payment.status == null) {
        response.data.data.orderList.results[i].payment.status = "---";
      }
    }

    return response.data.data.orderList.results.reverse();
  }
}
